import React from "react";
import styled from "styled-components";

export default function DonateOnceHero({ monthly }) {
	return (
		<SectionContainer>
			<div className="heading-container">
				<h1>
					Why you should {monthly ? "Donate Monthly" : "Donate"} to us
				</h1>
				<p>
					Your generous support will go directly to providing support
					and assistance to our community’s most vulnerable including
					children, those living with a mental illness, victims of
					violence and the homeless. Help build our community and
					inspire hope today.
				</p>
			</div>
		</SectionContainer>
	);
}

const SectionContainer = styled.section`
	.heading-container {
		margin-bottom: 2.5rem;

		h1 {
			margin-bottom: 0.5rem;
			text-align: center;
			font-size: 1.5rem;
			line-height: normal;
		}

		p {
			text-align: center;
		}

		@media (min-width: 768px) {
			margin-bottom: 90px;

			h1 {
				margin-bottom: 30px;
				font-size: 3rem;
			}

			p {
				max-width: 641px;
				margin: auto;
				color: #4a4a4a;
			}
		}
	}
`;
